import type {
  ComponentValueResponse,
  ResolveIdentityConflictRequest,
  ResolveIdentityConflictResponse,
  SaveComponentValueResponse,
  SumsubVerificationPreviousAnswer,
} from "@repo/shared/types";
import { getWithToken, postWithToken } from "../_client";

const BASE = "/public/flow/sumsub-verification";

export function getPublicSumsubVerificationValue(token: string) {
  return getWithToken<ComponentValueResponse>(`${BASE}/flow-instance-value`, token);
}

export function savePublicSumsubVerification(token: string, data: unknown) {
  return postWithToken<SaveComponentValueResponse>(`${BASE}/flow-instance-value`, token, data);
}

export function getPublicSumsubVerificationPreviousAnswer(token: string) {
  return getWithToken<SumsubVerificationPreviousAnswer>(`${BASE}/previous-answer`, token);
}

/** QL-f — same two endpoints as the advisor page; see the public route for why. */
export function getPublicIdentityConflicts(token: string) {
  return getWithToken<ResolveIdentityConflictResponse>(`${BASE}/identity-conflict`, token);
}

export function resolvePublicIdentityConflict(
  token: string,
  payload: ResolveIdentityConflictRequest,
) {
  return postWithToken<ResolveIdentityConflictResponse>(
    `${BASE}/identity-conflict`,
    token,
    payload satisfies ResolveIdentityConflictRequest,
  );
}
